import { Icon, IconNames } from '@triumph/design-system';
import { AppliedFilterChips } from './AppliedFilterChips';
import { FiltersToggleBar, FiltersToggleButton } from './FilterDrawer.styles';

export interface FiltersToggleProps {
    isOpen: boolean;
    onToggle: () => void;
    appliedCount: number;
    appliedChips: Array<{ id: string; label: string }>;
    onRemoveChip: (id: string) => void;
    onOverflowClick: () => void;
}

export function FiltersToggle({
    isOpen,
    onToggle,
    appliedCount,
    appliedChips,
    onRemoveChip,
    onOverflowClick,
}: FiltersToggleProps) {
    const hasActiveFilters = appliedCount > 0;

    return (
        <FiltersToggleBar data-testid="filter-toggle">
            <FiltersToggleButton
                type="button"
                onClick={onToggle}
                hasActiveFilters={hasActiveFilters}
                aria-expanded={isOpen}
                aria-label={`Filters (${appliedCount} active)`}
            >
                <Icon
                    name={
                        hasActiveFilters
                            ? IconNames.Interface_FilterFilled
                            : IconNames.Interface_FilterOutlined
                    }
                    size={14}
                    id="filters-toggle-icon"
                    color={hasActiveFilters ? '#ffffff' : '#0a1e3a'}
                />
                Filters ({appliedCount})
            </FiltersToggleButton>
            {appliedChips.length > 0 && (
                <AppliedFilterChips
                    layout="inline"
                    filters={appliedChips}
                    overflow={3}
                    onRemove={onRemoveChip}
                    onOverflowClick={onOverflowClick}
                />
            )}
        </FiltersToggleBar>
    );
}
